import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleLeft,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { Loader, LoaderContainer } from "../../Loader";
import "./TitleMdLg.css";
import "../../../index.css";

const TitleMdLg = (props) => {
  const {
    count,
    loading,
    navProjectIds,
    project: { category, id, subtitle, title },
  } = props;

  return loading ? (
    <Row>
      <Col sm={12} className="visible-md visible-lg">
        <LoaderContainer>
          <Loader align="left" sizes={[100, 60]} spacer={10} />
          <Loader align="left" sizes={[100, 30]} spacer={20} />
        </LoaderContainer>
      </Col>
    </Row>
  ) : (
    <Row className="visible-md visible-lg">
      <Col md={12} className="TitleMdLg__ctn">
        <div className="TitleMdLg__title">
          <strong>{title}</strong>
        </div>

        {props.count > 1 && (
          <div className="TitleMdLgLinksContainer">
            <Link
              className="TitleMdLgLink TitleMdLgLinkPrev"
              to={`/${category}/${navProjectIds.prev}`}
            >
              <FontAwesomeIcon icon={faArrowCircleLeft} />
            </Link>
            Project {id}/{count}
            <Link
              className="TitleMdLgLink TitleMdLgLinkNext"
              to={`/${category}/${navProjectIds.next}`}
            >
              <FontAwesomeIcon icon={faArrowCircleRight} />
            </Link>
          </div>
        )}
      </Col>

      {subtitle && (
        <Col md={12} className="TitleMdLg__subtitle">
          {subtitle}
        </Col>
      )}
    </Row>
  );
};

export default TitleMdLg;



// WEBPACK FOOTER //
// ./src/components/Project/TitleMdLg/TitleMdLg.js